import { render, staticRenderFns } from "./OpNumberTextField.vue?vue&type=template&id=45a6707f"
import script from "./OpNumberTextField.vue?vue&type=script&lang=js"
export * from "./OpNumberTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports